import { Input } from "~/components/ui/input";
import { Label } from "~/components/ui/label";
import { useContext } from "react";
import { BookingFormContext } from "~/components/booking/ContextProvider";
import { useDebouncedState } from "~/utils/hooks/use-debounced-state";

export const NameInput = () => {
  const context = useContext(BookingFormContext);
  if (!context) {
    throw new Error("BookingFormContext is not provided");
  }

  const { name, setName } = context;

  const [value, setValue] = useDebouncedState(name, setName);

  return (
    <div className="grid w-full items-center gap-1.5 px-6">
      <Label htmlFor="name">Name *</Label>
      <div className="mt-2" />
      <Input
        type="name"
        id="name"
        placeholder="Name"
        value={value}
        onChange={(event) => setValue(event.target.value)}
      />
    </div>
  );
};
